/**
 * 是否含有类名
 * @param el - dom对象
 * @param className - 含有指定的类名
 */
export function hasClass(el: Element, className: string) {
  return el.classList?.length ? el.classList.contains(className) : false;
}

/**
 * 添加类名
 * @param el - dom对象
 * @param className - 添加的类名
 */
export function addClass(el: Element, className: string) {
  if (el) {
    el.classList.add(className);
  }
}

/**
 * 移除类名
 * @param el - dom对象
 * @param className - 移除指定的类名
 */
export function removeClass(el: Element, className: string) {
  if (el) {
    el.classList.remove(className);
  }
}
